import { Column } from 'devextreme-react/data-grid';
import React from 'react';
import { formatMessage } from 'devextreme/localization';
import columnDataGrid from './columnDataGrid';
import DataGridMVP from '../../DataGridMVP';
import useWasteColumns from '../../../hooks/useWasteColumns';

const CorrectionSemiProductsTable = ({
  correctionSemiProductsReducer: { semiProducts, loading },
  inputReadyProductReducer
}) => {
  const [withWasteData, wasteColumns] = useWasteColumns(semiProducts);

  return (
    <>
      <DataGridMVP
        className="shipment"
        setStateStoringName={'dataGridGetSemiProducts'}
        keyExpr="pieceNumId"
        visibleButtonDateRangePicker={false}
        visibleSummary={false}
        visibleGroupPanel={false}
        visibleInfoIcon={false}
        selectionMode={false}
        tText={formatMessage('textPeriod')}
        dataSource={withWasteData}
        loadingData={loading || inputReadyProductReducer.loading}
        filterDataGrid
      >
        {columnDataGrid.map((item) => (
          <Column
            dataField={item.dataField}
            caption={item.caption}
            visible={!item.notVisible}
            cellRender={item.cellRender}
            key={item.dataField}
            dataType={item.dataType}
            cssClass={item.cssClass}
            width={item.width ? item.width : undefined}
          />
        ))}
        {wasteColumns}
      </DataGridMVP>
    </>
  );
};

export default React.memo(CorrectionSemiProductsTable);
